import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from "@material-ui/core";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const BusTable = ({ onAdded, onSelectItem }) => {

    const classes = useStyles();
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const fetchCompanies = async () => {
            await fetch('http://biometick.com/buses/' + localStorage.getItem("userID"), {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.length > 0) {
                        setCompanies(data);
                    }
                })
                .catch(error => console.error(error));
        };
        fetchCompanies();
    }, []);

    const handleEdit = (item) => {
        // Navigate to edit location page
        onSelectItem(item);
        onAdded('modify');
    };

    const handleDeleteCompany = (id) => {
        fetch(`http://biometick.com/buses/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            if (res.ok) {
                setCompanies(companies.filter(location => location._id !== id));
            } else {
                throw new Error('Something went wrong');
            }
        }).catch(error => console.error(error));
    }

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="company table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Device</TableCell>
                        <TableCell>Staff</TableCell>
                        <TableCell>Routes (Stoppages)</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {companies.map((company) => (
                        <TableRow key={company._id}>
                            <TableCell>{company.name}</TableCell>
                            <TableCell>{company.device.deviceName}</TableCell>
                            <TableCell>{company.staff.name}</TableCell>
                            <TableCell>{company.route.map((object) => object.name + ', ')}</TableCell>
                            <TableCell >
                                <Button color="primary" onClick={() => handleEdit(company)}>Edit</Button>
                                <Button color="secondary" onClick={() => handleDeleteCompany(company._id)}>Delete</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BusTable;